import React from 'react';
import Modal from 'src/modules/shared/modal/components/modal';
import i18n from 'i18next';

const ConfirmModal = (props) => {
  const { children, onAccept } = props;
  const title = props.title || i18n.t('Are you sure you want to do this?');
  const cancel = props.cancel || i18n.t('Cancel');
  const accept = props.accept || i18n.t('OK');
  return (
    <Modal
      accept={accept}
      cancel={cancel}
      title={title}
      onAccept={onAccept}
    >
      {children}
    </Modal>
  );
};

export default ConfirmModal;



// WEBPACK FOOTER //
// ./src/modules/shared/modal/components/confirmModal.js